// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"4a2441bf","257":"354b44ae","273":"37041a36","304":"1764c960"}[chunkId] + ".chunk.js";
};